import documentPreviewModalSignal from './DocumentPreviewModal.signal';

export const showDocumentPreviewModal = ({ file, filename }) => documentPreviewModalSignal.update({ file, filename });

export const hideDocumentPreviewModal = () => documentPreviewModalSignal.reset();
